import Axios from "axios";
import getCognitoIdentityCallbacks from "./cognitoIdentityCallbacks";

let axios = Axios;

export const setBaseURL = (baseURL) => {
    axios = Axios.create({ baseURL });
};

export const changePassword = (data, options) => {
    return axios.post("/api/password", data, options);
}

export const getProvider = (data, options) => {
    return axios.post("/login/provider", data, options);
}

export const loginWithPassword = (data, options) => {
    return axios.post("/login/password", data, options);
}

export const signup = (data, options) => {
    return axios.post("/login/signup", data, options);
}

export const autoLinkEmail = (data, options) => {
    return axios.post("/auto-link/email", data, options);
}

export const linkAccount = (data, options) => {
    return axios.post("/api/link", data, options);
}

// TODO: name
export const initiateCognitoLoginFlow = (cognitoUser, authenticationDetails) => {
    return new Promise((resolve, reject) => {
        return cognitoUser.authenticateUser(
            authenticationDetails,
            getCognitoIdentityCallbacks(resolve, reject)
        );
    });
}

export const forgotPassword = (data, options) => {
    return axios.post("/api/forgotPassword", data, options);
}

export const acceptTokens = (data, options) => {
    return axios.post("/login/acceptTokens", data, options);
}
